export default __webpack_public_path__ + "static/media/Mask Group-1.fded3dd3.png";